// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__26Muy","requiredAsterisk":"Info_requiredAsterisk__3yUNQ"};